import { isEmpty } from 'lodash'
import React from 'react'

export const ProductCardTags = ({ product, isSmall = true }) => {
  const productLabelList = [
    ...(!isEmpty(product?.featured)
      ? [
        {
          item: product?.featured,
          color: 'quaternary',
        },
      ]
      : []),
    ...(!isEmpty(product?.hot_item)
      ? [
        {
          item: product?.hot_item,
          color: 'secondaryApp',
        },
      ]
      : []),
    ...(!isEmpty(product?.fresh_item)
      ? [
        {
          item: product?.fresh_item,
          color: 'primaryApp',
        },
      ]
      : []),
  ]

  return (
    <div
      className={`absolute overflow-hidden top-2 flex justify-start gap-y-2 w-full ${isSmall ? 'space-x-2' : 'space-x-2'
        }`}
    >
      {/* {badges?.length ? ( */}
      {productLabelList.length > 0 &&
        (productLabelList.length === 1 ? (
          <OfferBadge
            label={productLabelList[0]?.item?.name}
            className={`text-${productLabelList[0]?.color}`}
          />
        ) : (
          productLabelList.map((p, i) => (
            <OfferBadge key={i} label={p?.item?.name} className={`text-${p?.color}`} />
          ))
        ))}
      {/* ) : (
        <>
          {!isEmpty(product?.offer) ? (
            <CustomImage
              alt="Product Tag"
              src={safeImage(product.offer!.images)}
              className={isSmall ? 'h-[40px] w-[40px]' : 'h-[60px] w-[60px]'}
            />
          ) : (
            <></>
          )}
          {!isEmpty(product?.hot_item) &&
            !isEmpty(product?.hot_item?.images) ? (
            <CustomImage
              alt="Product Tag"
              src={safeImage(product.hot_item!.images)}
              className={isSmall ? 'h-[40px] w-[40px]' : 'h-[60px] w-[60px]'}
            />
          ) : (
            <></>
          )}
          {!isEmpty(product?.fresh_item) &&
            !isEmpty(product?.fresh_item?.images) ? (
            <CustomImage
              alt="Product Tag"
              src={safeImage(product.fresh_item!.images)}
              className={isSmall ? 'h-[40px] w-[40px]' : 'h-[60px] w-[60px]'}
            />
          ) : (
            <></>
          )}
        </>
      )} */}
    </div>
  )
}

const OfferBadge = ({ label, className }) => {
  return (
    <div
      className={`rounded ml-1 px-1 md:lg:p-1 text-xxxs lg:text-xs font-semibold ${className} border border-gray-50 bg-white shadow`}
    >
      {label}
    </div>
  )
}
